import ApiClient from "@/api/ApiClient.ts";

const state = {
  fleet: [],
};

const mutations = {
  setFleet(state, fleet) {
    state.fleet = fleet;
  },
};

const actions = {
  async getFleet2({ commit }, customParams = {}) {
    const { expireCache, ...params } = customParams;
    try {
      const api = ApiClient();
      let response = await api.get("fleet2", {
        params,
        cache: expireCache ? { etag: false } : true,
      });
      commit("setFleet", response.data);
      return response.data;
    } catch (error) {
      console.error("ERROR en getFleet2: ", error.message);
    }
  },
};

const getters = {
  fleet(state) {
    return state.fleet;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
